module.exports = __webpack_public_path__ + "img/794.74e72aad.jpg";